import type { FaireProductEntity } from "../../entity_types/product";

export const p_vm789xbk5h: FaireProductEntity = {
  token: "p_vm789xbk5h",
  type: "product",
  name: "Tiny Toys - Teeny Tiny Vital Organ (squishy toy)",
  brandToken: "b_83nqde8ah7",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/c2aae05ab014432ef331adae11a12f146b9df8f393780029b3f71abee9fe2116.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e31f29850eb320272043222fac4f70aa6f3a8a58af4994db79d17745ee91a26.jpeg",
    "https://cdn.faire.com/fastly/b11a6590e79431e670c541a70cc99fb5b4782c4790bc38d95c86ce046dad6664.jpeg",
    "https://cdn.faire.com/fastly/025c56e9ee609a5f723198e1b1a69b4a0df238f5120b0333bdbfc39a8619ad4c.jpeg",
    "https://cdn.faire.com/fastly/a31607e86f0e88b7918d0567ac78c5bba29590758d40f86d1a9cbc67fdc1f764.jpeg",
    "https://cdn.faire.com/fastly/c9750228b067007ef6a1630c474a54068bcccd38ca6b4ddf5d0d2cbb06d72ae8.jpeg",
  ],
  priceDollars: 2,
  description:
    'Get ready to squeeze, squish, and love your new favorite fidget with the Tiny Toys Teeny Tiny Vital Organ, a delightfully detailed tiny heart that’s equal parts science and silliness! This realistic, anatomically inspired squishy heart is made from soft, squeezable material that’s perfect for stress relief, sensory play, or simply as a conversation-starting collectible. \r\n\r\n Compact and durable, this palm-sized organ makes a great desk toy, study buddy, or gift for anatomy fans, science lovers, or anyone with a big sense of humor. Whether you’re a student learning about the human body, a teacher looking for a fun classroom prop, or just someone who loves weird little trinkets, this heart’s got you covered. \r\n\r\n Perfect for stress relief, tactile play, and quirky gifting, the Teeny Tiny Vital Organ fits right into the Tiny Toys lineup of irresistibly odd mini collectibles. Squeeze it when you need to relax, or display it proudly, it’s weirdly wonderful in all the right ways. \r\n\r\n•  Age Grade: 3+\r\n•  Product Dimensions: 2.44"" L x 1.90"" W x 3.50"" H\r\n•  Inner Pack Dimensions: 8.86"" L x 8.66"" W x 4.72"" H\r\n•  Material: Thermoplastic rubber\r\n•  Play Pattern: Fidget & sensory play\r\n•  Skill Development: Focus & stress relief\r\n•  Case Pack: 12',
  tags: [],
  msrpDollars: 3.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:41.092Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
